var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-summary',_vm._g({attrs:{"icon":"option","title":"オプション","scroll-to-id":_vm.scrollToId,"errors":_vm.errors}},_vm.$listeners),[_c('div',[_vm._v(_vm._s(_vm._excludeSameItem))])])}
var staticRenderFns = []

export { render, staticRenderFns }